export const sharedLayoutTransition = {
  type: 'spring',
  stiffness: 500,
  damping: 40,
  mass: 1,
  precision: 0.01,
};

export const MAX_BRANCH_DEPTH = 4;
